export default __webpack_public_path__ + "static/media/ic-close.0f03dbca.svg";